import React, { useState } from 'react';
import Select from 'react-select';
import { provinciasMunicipiosForDropdown } from '../../../utils/helpers';
import { localidades } from '../../../utils/localidades';

const RegistroDGIIForm = ({registro, sucursal, errors}) => {
    const [municipios, setMunicipios] = useState(registro.province ? localidades.find(l => l.value === registro.province).municipios : []);
    return (
        <>
            <div className="row">
                <input type="hidden" name="sucursal_id" value={sucursal.id} />
                <div className="col-md-6">
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Razón Social:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='name'
                                name='name'
                                defaultValue={registro.name || sucursal.nombre}
                            />
                            {errors.name && (
                                <small className='help-blockParams form-Text'>
                                    {errors.name[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Nombre Comercial:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='tradeName'
                                name='tradeName'
                                defaultValue={registro.tradeName}
                            />
                            {errors.tradeName && (
                                <small className='help-blockParams form-Text'>
                                    {errors.tradeName[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Sucursal:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='branchOffice'
                                name='branchOffice'
                                defaultValue={registro.branchOffice}
                            />
                            {errors.branchOffice && (
                                <small className='help-blockParams form-Text'>
                                    {errors.branchOffice[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>Identificación/RNC:</label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='identification'
                                name='identification'
                                defaultValue={registro.identification || sucursal.rnc}
                            />
                            {errors.identification && (
                                <small className='help-blockParams form-Text'>
                                    {errors.identification[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Tipo:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <select
                                type='text'
                                className='text-input form-control'
                                id='type'
                                name='type'
                                defaultValue={registro.type}>
                                <option value='' disabled>-Seleccionar-</option>
                                <option value='associated'>Associated</option>
                                <option value='main'>Main</option>
                            </select>
                            {errors.type && (
                                <small className='help-blockParams form-Text'>
                                    {errors.type[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Actividad Económica:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='economicActivity'
                                name='economicActivity'
                                defaultValue={registro.economicActivity}
                            />
                            {errors.economicActivity && (
                                <small className='help-blockParams form-Text'>
                                    {errors.economicActivity[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Sitio Web:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='website'
                                name='website'
                                defaultValue={registro.website}
                            />
                            {errors.website && (
                                <small className='help-blockParams form-Text'>
                                    {errors.website[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Dirección:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='address'
                                name='address'
                                defaultValue={registro.address || sucursal.direccion}
                            />
                            {errors.address && (
                                <small className='help-blockParams form-Text'>
                                    {errors.address[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Provincia:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <Select
                                id='province'
                                name='province'
                                menuPlacement="auto"
                                menuPosition="fixed"
                                defaultValue={localidades.filter(l => l.value === registro.province)}
                                onChange={(e) => {
                                    setMunicipios(e.municipios);
                                }}
                                options={localidades}
                            />
                            {errors.province && (
                                <small className='help-blockParams form-Text'>
                                    {errors.province[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Municipio:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <Select
                                id='municipality'
                                name='municipality'
                                menuPlacement="auto"
                                menuPosition="fixed"
                                defaultValue={registro.municipality && localidades?.find(l => l.value === registro.province).municipios?.filter(m => m.value === registro.municipality)}
                                isDisabled={municipios.length === 0}
                                options={municipios}
                            />
                            {errors.municipality && (
                                <small className='help-blockParams form-Text'>
                                    {errors.municipality[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Email:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='email'
                                className='text-input form-control'
                                id='email'
                                name='email'
                                maxLength={80}
                                defaultValue={registro.email}
                            />
                            {errors.email && (
                                <small className='help-blockParams form-Text'>
                                    {errors.email[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Teléfono:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='text'
                                className='text-input form-control'
                                id='phone'
                                name='phone'
                                maxLength={80}
                                defaultValue={registro.phone}
                            />
                            {errors.phone && (
                                <small className='help-blockParams form-Text'>
                                    {errors.phone[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Notificar por Correo
                            </label>
                        </div>
                        <div className='col-md-8'>
                            <input type="hidden" name="notificationByEmail" value="no" />
                            <label className='switch switch-3d switch-success mr-3'>
                                <input
                                    type='checkbox'
                                    className='switch-input'
                                    name='notificationByEmail'
                                    value='yes'
                                    defaultChecked={registro.notificationByEmail}
                                />
                                <span className='switch-label' />
                                <span className='switch-handle' />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-md-6">
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Certificado:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='file'
                                id='certificate[file]'
                                name='certificate[file]'
                            />
                            {errors.certificado && (
                                <small className='help-blockParams form-Text'>
                                    {errors.cerfificado[0]}
                                </small>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Vencimiento:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='date'
                                className='text-input form-control'
                                id='certificate[expiration_date]'
                                name='certificate[expiration_date]'
                                maxLength={80}
                                defaultValue={registro.certificate?.expiration_date}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default RegistroDGIIForm;
